export default __webpack_public_path__ + "static/kig-032b2817b6b5d0057207af029ed2231b.png";